import { Videos } from '../_app/cuchillo/components/Videos';
import { Acordions } from '../_app/cuchillo/components/Acordions';
import { Basics, isTouch } from '../_app/cuchillo/core/Basics';
import Forms from '../_app/cuchillo/forms/FormValidator';
import { ControllerPage } from '../_app/cuchillo/pages/ControllerPage';
import Page from '../_app/cuchillo/pages/Page';
import { Scroll } from '../_app/cuchillo/scroll/Scroll';
// import Scrollbar from '../_app/cuchillo/scroll/Scrollbar';
import Preloader from '../layout/Preloader';
import Wrap from '../layout/Wrap';
import Keyboard from '../_app/cuchillo/core/Keyboard';
import { GetBy } from '../_app/cuchillo/core/Element';
import CMP from '../windows/Cmp';

export default class Default extends Page {
  constructor() {
    super();

    Videos.init();
    Acordions.init();
    Forms.init();

    [...GetBy.selector('[data-toggle-cmp]')].map(item => {
      item.addEventListener(Basics.clickEvent, CMP._calls.click);
    });
  }

  //SHOW
  beforeShow() {
    super.beforeShow();
    Scroll.init(Scroll.AXIS_Y, { domResize: this.container, smooth: !isTouch, multiplicator: 1 });
    // Scroll.setScrollbar(new Scrollbar());
    Scroll.directGoto(0);
    Keyboard.mountPage(this.id);

    // if (this.isFirstTime) {
    // }

    this.loadBookingWidget()
  }

  show__effect(__call) {
    if (this.isFirstTime) {
      Wrap.show(() => {
        Preloader.hide(() => { this.afterShow() });
      });
    } else {
      Wrap.show(() => { this.afterShow() });
    }
  }

  afterShow() {
    super.afterShow();
    Scroll.start();
    Scroll.show();
  }

  //HIDE
  beforeHide() {
    Keyboard.unmountPage(this.id);
    super.beforeHide();
  }

  hide__effect() {
    Scroll.hide();
    Wrap.hide(() => { this.afterHide(); });
  }

  afterHide() {
    Scroll.dispose();
    super.afterHide();

    [...GetBy.selector('[data-toggle-cmp]')].map(item => {
      item.removeEventListener(Basics.clickEvent, CMP._calls.click);
    });
  }

  loadBookingWidget() {
    if (!document.getElementById("horizontal-toprent-app-booking-widget")) return;

    const js = document.getElementById("power-booking-widget-script");
    if (js) js.remove();

    const script = document.createElement("script");
    script.src = "https://cloud.toprent.app/widget/horizontal-toprent-app-booking-widget.js";
    script.id = "power-booking-widget-script";
    script.async = true;
    script.defer = true;

    // script.onload = () => {
    // console.log("Booking widget carregat!!");
    // Aquí potser cal tornar a inicialitzar el widget si el script no ho fa automàticament.
    // };

    document.body.appendChild(script);
  }
  //RESIZE
  resize() {
    super.resize();
    Acordions.resize();
  }

  //LOOP
  loop() {
    if (this._isActive) {
      super.loop();
    }
  }
}

ControllerPage._addPage('default', Default);
